import { DestinationTypeValues } from "../common/ObjectTypes";

// NOTE: Only add destination types here whose URL field should be hidden entirely
// (e.g. types that derive their URL from config, not user input). Do NOT add
// EarthRanger or other types that merely transform how the URL field is displayed.
export const isHiddenUrlDestinationType = (value: string): boolean => {
    return Object.values(DestinationTypeValues).includes(value as DestinationTypeValues);
};